import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_EPISODE_EXPANDER]: 'Show all {episodeCount} episodes',
  [StringId.DV_DP_EPISODE_NUM_ASCENDING]: 'Episode Number',
  [StringId.DV_DP_EPISODE_NUM_DESCENDING]: 'Newest Episodes',
  [StringId.DV_DP_EPISODE_AVAILABLE]: 'Available to Watch',
  [StringId.DV_DP_EPISODE_SORT_BY]: 'Sort by',
}